import {
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  SET_TOKEN,
  EMPTY_ERROR,
  LOGOUT,
  SET_LOADING_USER,
  SIGN_UP_SUCCESS,
  SIGN_UP_FAILURE,
  GET_USER_SUCCESS,
  GET_USER_FAILURE,
  UPDATE_USER_FAILURE,
  UPDATE_USER_SUCCESS
} from './types';

const initialState = {
  user: null,
  isLoggedIn: false,
  isLoadingUser: false,
  error: null,
  token: null,
  editUser: false
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload.paciente,
        token: action.payload.paciente.token,
        isLoggedIn: true,
        isLoadingUser: false,
        error: null,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        user: null,
        isLoggedIn: false,
        isLoadingUser: false,
        error: action.payload.response.data.error,
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        user: { ...action.payload.paciente },
        token: action.payload.paciente.token,
        isLoadingUser: false,
        editUser: true,
        error: null,
      };
    case UPDATE_USER_FAILURE:
      return {
        ...state,
        editUser: false,
        isLoadingUser: false,
        error: action.payload.response.data.error,
      };
    case SIGN_UP_SUCCESS:
      return {
        ...state,
        user: action.payload.paciente,
        token: action.payload.paciente.token,
        isLoggedIn: true,
        isLoadingUser: false,
        error: null,
      };
    case SIGN_UP_FAILURE:
      return {
        ...state,
        user: null,
        isLoggedIn: false,
        isLoadingUser: false,
        error: action.payload.response.data.error,
      };
    case GET_USER_SUCCESS:
      return {
        ...state,
        user: action.payload,
        isLoadingUser: false,
        error: null
      };
    case GET_USER_FAILURE:
      return {
        ...state,
        user: null,
        isLoadingUser: false,
        error: action.payload
      };
    case EMPTY_ERROR:
      return {
        ...state,
        error: null,
      };
    case SET_LOADING_USER:
      return {
        ...state,
        isLoadingUser: true
      };
    case SET_TOKEN:
      return {
        ...state,
        token: action.payload,
      };
    case LOGOUT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default userReducer;
